export default __webpack_public_path__ + "static/media/Office.8fd9da35.png";